var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRefresh(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "a",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    transform: "matrix(-1 0 0 1 20 0)",
    fill: "#D9D9D9",
    d: "M0 0h20v20H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10 18.333c1.945 0 3.622-.639 5.031-1.916 1.41-1.278 2.22-2.861 2.428-4.75a.683.683 0 0 0-.199-.584.788.788 0 0 0-.593-.25c-.222 0-.42.08-.594.24a.932.932 0 0 0-.302.594 5.618 5.618 0 0 1-1.917 3.573c-1.083.951-2.367 1.427-3.854 1.427-1.625 0-3.003-.566-4.135-1.699-1.132-1.131-1.698-2.51-1.698-4.135s.566-3.003 1.698-4.136C6.997 5.566 8.375 5 10 5h.125l-.729.73a.79.79 0 0 0-.229.582.823.823 0 0 0 .833.833c.236 0 .43-.082.584-.25L12.75 4.75a.725.725 0 0 0 .177-.27.916.916 0 0 0 .053-.313.916.916 0 0 0-.053-.313.725.725 0 0 0-.177-.27l-2.166-2.167a.79.79 0 0 0-.584-.23.862.862 0 0 0-.604.23.862.862 0 0 0-.229.604c0 .236.076.43.23.583l.728.73H10a7.254 7.254 0 0 0-2.927.594c-.91.395-1.701.93-2.375 1.603a7.64 7.64 0 0 0-1.604 2.375 7.263 7.263 0 0 0-.594 2.927c0 1.042.198 2.018.594 2.927.396.91.93 1.702 1.604 2.375a7.632 7.632 0 0 0 2.375 1.605c.91.396 1.886.593 2.927.593z",
    fill: "#4D4D4D"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefresh);
export default __webpack_public_path__ + "static/media/refresh.f599a259f95753424e8927b04465ee9c.svg";
export { ForwardRef as ReactComponent };